module.exports = function(vars) {
var __t, __p = '', __e = _.escape;
__p += '<i class="fa fa-close close-button fullscreen-overlay-close"></i>\n<div class="player-segment fullscreen-overlay-segment">\n  <h1>Oops, the fullscreen failed :( </h1>\n	<p class="fullscreen-text"><br> Click “Open” to open the player on a fullscreen friendly page.</p>\n	<a class="btn btn-default broadcast-button btn-lg" target="_blank" href="' +
__e( vars.link ) +
'"> Open</a>\n  <a class="btn btn-default fullscreen-overlay-close broadcast-button btn-lg" target="_blank"><i class="fa fa-reply"></i> Back</a>\n</div>\n';
return __p
}


// WEBPACK FOOTER //
// ./src/templates/fullscreen-overlay.ejs